import React, { useEffect, useMemo, useState } from 'react';
import commons from 'frontend/commons/commons';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { useDispatch, useSelector } from 'react-redux';
import { getBanners } from 'frontend/redux/actions/banners-actions';
import styles from './mainCarousel.module.css';
import MainCarouselSlide from './MainCarouselSlide';

const MainCarousel = ({ defaultB = true, id, defaultOnly, showHomeOnly }) => {
  const dispatch = useDispatch();
  const [showDefault, setShowDefault] = useState(false);
  useEffect(() => {
    dispatch(getBanners({ id, esDefault: defaultB, defaultOnly, showHomeOnly }));
  }, []);

  const { categoriesMainCarousel, ready, error } = useSelector((state) => state.bannersState);
  useEffect(() => {
    if (ready && (error || !categoriesMainCarousel || categoriesMainCarousel.length === 0)) {
      setShowDefault(true);
    }
  }, [categoriesMainCarousel]);

  const content = useMemo(() => {
    if (!ready) {
      return (
        <div
          className={`${styles.carouselImgItemLoading} animate-pulse flex justify-center items-center`}
        >
          <span />
        </div>
      );
    }
    const sliders =
      ready &&
      !error &&
      categoriesMainCarousel &&
      categoriesMainCarousel.reduce((acc, cur) => {
        const slides = cur.banner.map((banner) => (
          <div key={banner.title + banner.url}>
            <MainCarouselSlide banner={banner} />
            <a href={banner.url} className="block">
              <div
                className="absolute flex flex-row top-80 left-48 right-48  h-full
            justify-center items-baseline
              -ml-3 "
              >
                <div className={`${styles.carrouselTitleContainer} flex flex-row items-baseline `}>
                  {banner.descuento !== '' && (
                    <div className={`${styles.carrouselDiscount}  rounded-lg py-5 px-3`}>
                      {banner.descuento}
                    </div>
                  )}

                  <div className={`${styles.carrouselTitle} text-left border-r-2  px-5 ml-5  `}>
                    {commons.filterText(banner.title)}
                  </div>
                  <div className={`${styles.carrouselPrice}  pl-5 filter `}>
                    {banner.price && banner.price.length > 0 && banner.price[0].currency}{' '}
                    {banner.price &&
                      banner.price[0] !== 0 &&
                      commons.numberFixedToMoney(commons.finalPrice(banner.price[0]), 0)}
                  </div>
                  <div className={`${styles.carrouselPrice}  px-7 filter `}>
                    {banner.manualPrice !== null &&
                      banner.manualPrice !== '0' &&
                      banner.manualPrice}
                  </div>
                  {banner.tag !== '' && (
                    <div className={`${styles.carrouselExtra}  rounded-lg py-5 px-5`}>
                      {banner.tag}
                    </div>
                  )}
                </div>
              </div>
            </a>
          </div>
        ));

        return acc.concat(slides);
      }, []);
    return sliders;
  }, [ready, showDefault, categoriesMainCarousel]);

  return (
    <>
      {!showDefault && (
        <Carousel
          infiniteLoop={!showDefault}
          showArrows={!showDefault}
          showIndicators={false}
          showThumbs={false}
          showStatus={false}
          autoPlay={true}
          interval={3000}
        >
          {content}
        </Carousel>
      )}
    </>
  );
};

export default MainCarousel;
